import { useTeams } from "../api/queries/useTeams"
import { MultiSelect } from "primereact/multiselect"

export default function TeamMultiFilter(props) {
  const { data: teams = [] } = useTeams()

  return (
    <MultiSelect
      showClear={true}
      filter={true}
      options={teams}
      optionLabel={"name"}
      optionValue={"uuid"}
      placeholder={"Tým"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      onChange={props.onChange}
    />
  )
}
